import { defineCopy } from "@tami/core/intl";

import { HEADER_PUBLIC_COPY_EN_US } from "./en-us/header.copy";
import { HEADER_PUBLIC_COPY_ES_ES } from "./es-es/header.copy";

/** Cabeçalho do site público (só-web). */
export const HEADER_PUBLIC_COPY_PT_BR = {
  homeAria: "Tãmi — ir para o início",
  nav: {
    offer: "O que a Tãmi oferece",
    testimonials: "Depoimentos",
    pricing: "Valores",
  },
  signInDesktop: "acessar",
  signInMobile: "Acessar",
  createAccount: "Crie sua conta",
  menuClose: "Fechar menu",
  menuOpen: "Abrir menu de navegação",
  mobileNavAria: "Menu de navegação",
} as const;

export const HEADER_PUBLIC_COPY = defineCopy(HEADER_PUBLIC_COPY_PT_BR, {
  "en-US": HEADER_PUBLIC_COPY_EN_US,
  "es-ES": HEADER_PUBLIC_COPY_ES_ES,
});
